import { BaseApiService } from '@shared/services/BaseApiService';

class RegisterServiceClass extends BaseApiService {
  constructor(opts) {
    super(opts);
  }

  checkEmailPhone(params = {}) {
    return this.http.post('/check-credentials', params);
  }
  register(params) {
    return this.http.post('/', params);
  }
}

export const RegisterService = new RegisterServiceClass({
  api_version: 2,
  resource: 'registration'
});
